import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AddFarmerImg from '../assets/icons/addFarmer.png';
import CollectMilkImg from '../assets/icons/collectMilk.png';
import DuesImg from '../assets/icons/dues.png';
import LedgerImg from '../assets/icons/ledger.png';
import PaymentsImg from '../assets/icons/payments.png';
import RateChartImg from '../assets/icons/rateChart.png';
import Bills from '../assets/icons/bill.png';
import MilkReportImg from '../assets/icons/milkreport.png'; // Corrected the import name
import { Image } from 'react-bootstrap';

const screens = [
  { name: 'Add Farmer', component: 'AddFarmer', image: AddFarmerImg },
  { name: 'Collect Milk', component: 'CollectMilk', image: CollectMilkImg },
  { name: 'Payments', component: 'Payments', image: PaymentsImg },
  { name: 'Rate Chart', component: 'RateChart', image: RateChartImg },
  { name: 'Dues', component: 'Dues', image: DuesImg },
  { name: 'Ledger', component: 'Ledger', image: LedgerImg },
  { name: 'Milk Report', component: 'MilkReport', image: MilkReportImg },
  { name: 'Generate Bill', component: 'Bills', image: Bills },
];

const Features = ({ route }) => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get("username")
  const navigator = useNavigate();

  const handleNavigation = (component) => {
    navigator(`${component}?username=${username}`);
  };

  return (
    <div className="min-h-screen bg-green-200 flex items-center justify-center">
      <div className="bg-white p-8 rounded shadow-md">
        <div className="flex flex-wrap justify-center">
          {screens.map(({ name, component, image }) => (
            <div
              key={component}
              className="m-4 p-4 text-center cursor-pointer"
              onClick={() => handleNavigation(component)}
            >
              <img src={image} alt={name} className="w-16 h-16 mx-auto mb-2" />
              <div className="text-sm">{name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
